import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from './components/HeroCarousel';
import CategoryNav from './components/CategoryNav';
import ArticleList from './components/ArticleList';
import HomeSidebar from './components/HomeSidebar';
import { siteInfo } from '@/mocks/articles';
import { generateOrganizationSchema, generateWebSiteSchema, generateWebPageSchema, generateBreadcrumbSchema } from '@/components/feature/StructuredData';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const pageTitle = `${siteInfo.name} - ${siteInfo.tagline}`;
  const canonicalUrl = `https://${siteInfo.domain}`;

  const organizationLD = generateOrganizationSchema();
  const webSiteLD = generateWebSiteSchema();
  const webPageLD = generateWebPageSchema(
    pageTitle,
    siteInfo.description,
    canonicalUrl,
    [{ name: '首页', url: canonicalUrl }]
  );

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={canonicalUrl}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationLD) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteLD) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageLD) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroCarousel />
          <CategoryNav activeSlug="all" />

          <section className="w-full px-4 md:px-6 py-8">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    📰 最新爆料
                  </h2>
                  <span className="text-sm text-foreground-500">
                    共 12 篇
                  </span>
                </div>
                <ArticleList />
              </div>

              <div className="lg:w-[320px] flex-shrink-0">
                <HomeSidebar />
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}